import { render, staticRenderFns } from "./ProductDetailPage.vue?vue&type=template&id=f1f6ee84&scoped=true"
import script from "./ProductDetailPage.vue?vue&type=script&lang=js"
export * from "./ProductDetailPage.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailPage.vue?vue&type=style&index=0&id=f1f6ee84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f6ee84",
  null
  
)

export default component.exports